<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <h1>Категории ингредиентов</h1>
      <v-row align="center">
        <v-col class="text-right" >
          <v-dialog v-model="dialog" max-width="445">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                      v-bind="attrs"
                      v-on="on"
              >
                Создать категорию
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ modifierCategory.id ? 'Редактировать категорию' : 'Создать категорию'}}</span>
              </v-card-title>
              <v-card-text>
                <v-tabs v-model="tab">
                  <v-tab>RU</v-tab>
                  <v-tab>UA</v-tab>
                </v-tabs>
                <v-form ref="tabForm" v-model="valid">
                <v-tabs-items v-model="tab" class="">
                  <v-tab-item :eager="true">
                    <v-text-field
                            label="Название"
                            outlined
                            v-model="modifierCategory.name"
                            :rules="[rules.required]"
                            required>
                    </v-text-field>
                  </v-tab-item>
                  <v-tab-item :eager="true">
                    <v-text-field
                            label="Название"
                            outlined
                            v-model="modifierCategory.name_ua"
                            :rules="[rules.required]"
                            required
                    ></v-text-field>
                  </v-tab-item>
                </v-tabs-items>
                </v-form>
              </v-card-text>
              <v-card-actions class="text-left">

                <v-btn v-if="modifierCategory.id" @click="updateTag()" :loading="loadingModal">Сохранить</v-btn>
                <v-btn v-else @click="createTag()" :loading="loadingModal">Добавить</v-btn>
                <v-btn @click="dialog = false" outlined>Отменить</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет категорий ингредиентов"
              no-results-text="По заданному запросу ничего не найдено"
              :headers="headers"
              :items="modifierCategories"
              :options.sync="options"
              :footer-props="footerProps"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :loading="loading"
              loading-text="Загрузка категорий... Подождите пожалуйста"
      >
        <template v-slot:item.actions="{ item }">
          <div class="text-right">

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                        small
                        class="mr-2"
                        v-bind="attrs"
                        v-on="on"
                >
                  mdi-dots-vertical
                </v-icon>
              </template>
              <v-list>
                <v-list-item @click="modifierCategory = Object.assign({}, item); dialog = true">
                  <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="submitDialog = true; submitItem = item">
                  <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
    <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
            :color="snackbarColor"
            right
            top
    >
      {{ snackbarText }}
    </v-snackbar>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
    // @ is an alias to /src

    import ModifierCategoryService from './../../api/ModifierCategoryService'

    export default {
        name: 'ProductIndex',
        components: {},
        data: () => ({
            snackbar: false,
            timeout: 2000,
            snackbarText: '',
            snackbarColor: '',
            valid: false,
            submitDialog: false,
            submitItem: null,
            overlay: false,
            loadingModal: false,
            loading: true,
            tab: null,
            dialog: false,
            modifierCategories: [],
            options: {},
            modifierCategory: {
                id: null,
                name: '',
                name_ua: '',
            },
            rules: {
              required: value => !!value || 'Нужно заполнить',
              requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
            },
            footerProps: {
                itemsPerPageText: 'Категорий на страницу',
                pageText: '{0}-{1} из {2}',
                itemsPerPageAllText: 'Все',
                itemsPerPageOptions: [-1]
            },
            headers: [
                {
                    text: 'Категория',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Количество',
                    value: 'modifiers_count',
                    sortable: false
                },
                {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
            ],
        }),
        mounted() {
        },
        watch: {
            options: {
                handler() {
                    this.getDataFromApi()
                },
                deep: true,
            },
        },
        methods: {
          submitDelete(item = null){
            if(item){
              this.removeTag(item)
            } else {
              // this.massDelete()
            }
          },
            validate(){
              this.$refs.tabForm.validate()
              if(this.modifierCategory.name == '' && this.modifierCategory.name_ua != ''){
                this.tab = 0;
              }
              if(this.modifierCategory.name != '' && this.modifierCategory.name_ua == ''){
                this.tab = 1;
              }
            },
            removeTag(item){
              ModifierCategoryService.remove(item.id).then(response => {
                  this.loading = true
                  this.getDataFromApi()
              })
            },
            createTag(){
              this.validate();
              if(!this.valid){
                return false;
              }
                this.loadingModal = true;
                ModifierCategoryService.create(this.modifierCategory).then(response => {
                    this.getDataFromApi();
                    this.snackbar = true;
                    this.snackbarText = 'Категория создана';
                    this.snackbarColor = 'success';
                }).catch(error => {
                  this.snackbar = true;
                  this.snackbarText = 'Ошибка при создании категории';
                  this.snackbarColor = 'error';
                }).finally(() => {
                    this.dialog = false;
                    this.loadingModal = false;
                })
            },
            updateTag(){
              this.validate();
              if(!this.valid){
                return false;
              }
                this.loadingModal = true;
                ModifierCategoryService.update(this.modifierCategory).then(response => {
                    this.getDataFromApi();
                    this.snackbar = true;
                  this.snackbarText = 'Категория обновлена';
                  this.snackbarColor = 'success';
                }).catch(error => {
                  this.snackbar = true;
                  this.snackbarText = 'Ошибка при обновлении категории';
                  this.snackbarColor = 'error';
                }).finally(() => {
                    this.dialog = false;
                    this.loadingModal = false;
                })
            },
            getDataFromApi() {
                this.loading = true
              this.selected = [];
                ModifierCategoryService.list({})
                    .then(response => {
                        this.modifierCategories = response.data
                        this.loading = false
                    })
            },
        }
    }
</script>

<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }
  span.v-btn{
    border-color: currentColor!important;
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }



    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
